const INIT_URL = "init_url";
const LOB = "trackshipment";

const API_TOKEN =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1ODcwMTU0OTksImV4cCI6MTYxODU1MTU2MywiYXVkIjoibXNyIGNvc21vcyIsInN1YiI6InBhdmFuQGV4YW1wbGUuY29tIiwiR2l2ZW5OYW1lIjoiQ29zbW9zIiwiU3VybmFtZSI6Im1zciIsIkVtYWlsIjoicGF2YW5AZXhhbXBsZS5jb20iLCJSb2xlIjpbInJhdmkiLCJzdXJlc2giXX0.fftTinP-0dPxBXAc2DiickrvE5h24yMiXkEdIu60jWE";
const TRAVEL_LIMIT = 400;
const CREDIT_LIMIT = 10000000;

// SFTO Fee Calculation
const CHARGEABLE_WEIGHT = 2830.0;
const BFNSM_CARRYING_CAPACITY = 69.6;
const BFNS_CARRYING_CAPACITY = 64.9;
const OVER_WEIGHT_PUNITIVE = 0;
const REBATE = 0.12;
const BUSY_SEASON_SURCHARGE = 0.15;
const DEV_SURCHARGE = 0.05;
const TACPERMT = 20;
const BASE_CHARGEABLE_WEIGHT = 2838.0;
const SLAB1_REBATE_PERCENTAGE = 0.02;
const SLAB2_REBATE_PERCENTAGE = 0.04;
const SLAB3_REBATE_PERCENTAGE = 0.06;
const SLAB4_REBATE_PERCENTAGE = 0.08;
// SFTO Fee Calculations
const DEFAULT_LIST_VIEW_PAGINATION_OPTIONS = {
  RECORDS_PER_PAGE_OPTIONS: [5, 10, 20, 30],
  DEFAULT_RECORDS_PER_PAGE: 5,
  RECORDS_PER_CACHED_PAGE: 500,
  DEFAULT_RECORDS_PER_PAGE_PURCHASE_VIEW :30,
  DEFAULT_ORDERBY: "customer_name",
  SORTBY_ASC: true,
};
const DEFAULT_LINEITEMS_PER_PAGE = 10
const ALLOWED_EXTENSIONS = ["csv", "pdf", "xls", "xlsx", "doc", "docx"];
const MAX_UPLOAD_SIZE = 50000;
const GPWIS_JOB_EXEC_STEPS = [];

const MASTER_HORIZONTAL_STEPS = [
  "Master",
  "Custom Clearance",
  "Upload Documents",
  "Invoice Details",
  "Purchase Orders View",
  "Sales Orders View",
];

const MASTER_HORIZONTAL_STEPS_CONDITION = [
  "Master",
  "Master Summary",
  "House",
  "Custom Clearance",
  "Upload Documents",
  "Invoice Details",
  "Purchase Orders View",
  "Sales Orders View",
];

const HOUSE_HORIZONTAL_STEPS = [
  "House",
  "Custom Clearance",
  "Upload Documents",
  "Invoice Details",
  "Purchase Orders View",
  "Sales Orders View",
];





export default {
  INIT_URL,
  LOB,
  API_TOKEN,
  DEFAULT_LIST_VIEW_PAGINATION_OPTIONS,
  TRAVEL_LIMIT,
  CREDIT_LIMIT,
  CHARGEABLE_WEIGHT,
  OVER_WEIGHT_PUNITIVE,
  BUSY_SEASON_SURCHARGE,
  REBATE,
  DEV_SURCHARGE,
  TACPERMT,
  BASE_CHARGEABLE_WEIGHT,
  SLAB1_REBATE_PERCENTAGE,
  SLAB2_REBATE_PERCENTAGE,
  SLAB3_REBATE_PERCENTAGE,
  SLAB4_REBATE_PERCENTAGE,
  ALLOWED_EXTENSIONS,
  MAX_UPLOAD_SIZE,
  MASTER_HORIZONTAL_STEPS,
  MASTER_HORIZONTAL_STEPS_CONDITION,
  HOUSE_HORIZONTAL_STEPS,
  DEFAULT_LINEITEMS_PER_PAGE,
};
